<!--
 * @FilePath: /src/views/about.vue
 * @Description: 关于传发
-->
<template>
  <div>
    <header-view @same-router="sameRouter"></header-view>
    <div id="content" class="content-box">
      <div class="content-banner"></div>
      <div class="table-content">
        <div class="table-box f-cb">
          <div id="about">
            <ul id="about_toggle" class="nav f-fl">
              <li class="title">
                <h2>关于传发</h2>
                <span class="tip">ABOUT US</span>
              </li>
              <li @click="handlChangeTab('desc')" :class="{'active': item === 'desc'}">公司简介</li>
              <li @click="handlChangeTab('sh')" :class="{'active': item === 'sh'}">上海中心</li>
              <li @click="handlChangeTab('nc')" :class="{'active': item === 'nc'}">南昌中心</li>
            </ul>

            <div id="about_container">

              <div v-if="item === 'desc'" class="content f-fr">
                <div class="title f-cb">
                  <h3 class="f-fl">公司简介</h3>
                  <span class="des f-fr">
                    您的位置：首页 > 关于我们 > <span>公司简介</span>
                  </span>
                </div>
                <div class="con">
                  <div class="text">
                    <p class="indent">
                      传发金融是一家专业的金融服务公司，立志打造互金行业标杆企业，为战略合作伙伴业务保驾护航，提供高标准、全流程的服务。
                    </p>
                  </div>

                  <img src="../assets/images/c3.png" alt="" />
                </div>
              </div>

              <div v-if="item === 'sh'" class="content f-fr">
                <div class="title f-cb">
                  <h3 class="f-fl">上海中心</h3>
                  <span class="des f-fr">
                    您的位置：首页 > 关于传发 > <span>上海中心</span>
                  </span>
                </div>
                <div class="con">
                  <h3 class="title">传发金融上海中心概况</h3>
                  <img class="shanghai" src="../assets/images/c5.png" alt="" />

                  <div class="address">
                    <div class="f-cb">
                      <p class="p1 f-fl">职场地址：</p>
                      <p class="p2">
                        张江集电港地处上海市浦东新区张江高科技园区核心区，以完善的设施、优美的环境和优
                        质的配套服务成为科技领袖集聚之地和创新创业的乐土。
                      </p>
                    </div>
                    <div class="f-cb d2">
                      <p class="p1 f-fl">职场标准：</p>
                      <p class="p2">张江高科技园区核心区，约1900平方</p>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item === 'nc'" class="content f-fr">
                <div class="title f-cb">
                  <h3 class="f-fl">南昌中心</h3>
                  <span class="des f-fr">
                    您的位置：首页 > 关于传发 > <span>南昌中心</span>
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
import HeaderView from '@/components/header.vue'
import FooterView from '@/components/footer.vue'

export default {
  name: 'aboutView',
  data() {
    return {
      item: 'desc'
    }
  },
  created() {
    this.item = this.$route.params.item || 'desc'
  },

  methods: {
    handlChangeTab(tab) {
      this.item = tab
    },

    sameRouter(params) {
      this.handlChangeTab(params.item)
    }
  },

  components: { HeaderView, FooterView }
}
</script>

<style lang="stylus">
color = #f37a55;

.content-box {
  .content-banner {
    width: 100%;
    height: 290px;
    background: url('../assets/images/banner2.png') no-repeat;
    background-size: cover;
    background-position: center;
  }

  .table-content {
    width: 100%;
    padding-bottom: 130px;

    .table-box {
      width: 1200px;
      margin: 0px auto;
      margin-top: -34px;
    }
  }
}

.table-box {
  .nav {
    width: 234px;

    .title {
      h2 {
        margin: 10px 0;
      }

      width: 100%;
      height: 122px;
      font-size: 22px;
      color: white;
      background-color: color;
      padding: 26px;

      .tip {
        color: #f8a084;
      }
    }

    .active {
      border-left: 2px solid color;
      background-color: #f3f3f3;
    }

    li+li {
      cursor: pointer;
      position: relative;
      line-height: 32px;
      height: 64px;
      border-left: 1px solid #d5d5d5;
      border-right: 1px solid #d5d5d5;
      border-bottom: 1px solid #d5d5d5;
      padding: 16px;

      &:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-top: 6px solid #d5d5d5;
        border-left: 6px solid transparent;
        right: 10px;
        top: 50%;
        transform: rotate(45deg) translateY(-50%);
      }
    }
  }

  .hide {
    display: none;
  }

  .content {
    width: 947px;
    padding: 1px 42px 70px;
    background-color: white;
    border: 1px solid #d5d5d5;

    .contact-us {
      height: 314px;
      padding-top: 20px;
      text-align: center;

      .contact-us-title {
        text-align: center;
        padding-top: 35px;

        span {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #464647;
          line-height: 30px;
          margin-left: 16px;
          vertical-align: bottom;
        }
      }

      .contact-us-1 {
        display: block;
        margin: 0 auto;
      }

      .contact-us-module {
        width: 414px;
        height: 295px;
        background: #f8f8f8;
        box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.2);
        display: inline-block;

        .contact-us-content {
          padding: 28px 40px 52px 40px;
          text-align: left;

          p {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #464647;
            line-height: 32px;
          }
        }

        .contact-us-line {
          width: 372px;
          height: 1px;
          border: 1px solid #dfdfdf;
          margin: 0 auto;
          margin-top: 24px;
        }
      }
    }

    >.title {
      padding: 22px 0;
      height: 64px;
      border-bottom: 1px solid #d5d5d5;

      h3 {
        font-size: 18px;
        font-weight: normal;
        padding-left: 10px;
        height: 20px;
        line-height: 20px;
        width: 200px;
        color: #bdbcbd;
        border-left: 8px solid color;
      }

      .des {
        color: #c0c0c0;

        span {
          color: #D45A1A;
        }
      }
    }

    .addressTable {
      margin: 30px auto 40px;
      width: 846px;
      height: 50px;
      position: relative;

      &:before {
        content: '';
        display: block;
        position: absolute;
        width: 10px;
        height: 1px;
        top: 49px;
        left: 418px;
        background-color: #e1e1e1;
      }

      >.active {
        background-color: white;
        border-bottom: none;
      }

      >div {
        background-color: #f9f9f9;
        font-size: 18px;
        border: 1px solid #e1e1e1;
        width: 418px;
        height: 100%;
        line-height: 46px;
        text-align: center;
        background-color: #f4f4f4;
      }
    }

    .address-box {
      padding: 0px 5px;

      >div {
        display: none;
      }

      >.show {
        display: block;
      }
    }

    .con {
      line-height: 26px;

      >.title {
        color: #676767;
        text-align: center;
        font-size: 16px;
        margin: 65px auto 35px;
      }

      .indent {
        text-indent: 30px;
      }

      .top {
        margin-top: 20px;
      }

      .tip {
        margin-top: 40px;
        background-color: #f2f2f4;
        padding: 6px 10px;
      }

      .light {
        color: color;
        font-size: 16px;
        margin: 16px 0;
      }

      img {
        max-width: 100%;
        display: block;
        margin: 0 auto;
      }

      .shanghai {
        border: 2px solid #665a56;
      }

      .join {
        margin: 40px 150px;
      }

      .address {
        width: 700px;
        margin: 20px auto;
        line-height: 26px;

        .d2 {
          margin-top: 20px;
        }

        >div {
          width: 100%;

          .p1 {
            width: 84px;
          }

          .p2 {
            margin-left: 84px;
          }
        }
      }

      .text {
        color: #8a8a8a;
        margin: 20px 12px;
        line-height: 26px;

        >.title {
          color: #676767;
          font-size: 16px;
        }

        .email {
          color: #555559;
          font-size: 16px;
          font-weight: bold;

          a {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about.vue